import { createBrowserRouter } from 'react-router-dom';
import Materials from './components/pages/Materials/Materials';
import WorkpacksPage from './components/pages/Workpacks/Workpacks';
import ScaffoldsPage from './components/pages/Scaffolds/Scaffolds';
import LiftplansPage from './components/pages/Liftplans/Liftplans';
import NotFound from './components/pages/404';
import EmocsPage from './components/pages/Emocs/Emocs';
import EventsPage from './components/pages/Events/Events';
import JobsPage from './components/pages/Jobs/Jobs';
import JobDetailsPage from './components/pages/JobDetails/JobDetails';
import IsolationsPage from './components/pages/Isolations/Isolations';
import InsulationsPage from './components/pages/Insulation/Insulations';
import LeakTestPacksPage from './components/pages/LeakTestPacks/LeakTestPacks';
import ProceduresPage from './components/pages/Procedures/Procedures';
import PurchaseOrdersPage from './components/pages/PurchaseOrders/PurchaseOrders';
import HomePage from './components/pages/Home/HomePage';
import FAQ from './components/pages/Home/FAQ';
import PermitsPage from './components/pages/Permits/Permits';
import CertificatesPage from './components/pages/Certificates/Certificates';
import CertificateDetailsPage from './components/pages/CertificateDetails/CertificateDetails';
import { TARS_AND_OUTAGES_PATH, MAINTANENCE_PATH } from './constants';
import CertificateSearch from './components/organisms/CertificateSearch/CertificateSearch';
import JointDetails from './components/pages/JointDetails/JointDetails';
import JointsView from './components/pages/JointsView/JointsView';
import CertificateDetailsTabletPage from './components/pages/CertificateDetails/CertificateDetailsTablet';
import CertificateMonitoringPage from './components/pages/CertificateMonitoring/CertificateMonitoring';

// Router placeholder: later add Layout at the top and add App as an outlet
const router = createBrowserRouter([
  {
    path: '/',
    children: [
      {
        path: '',
        element: <HomePage />,
      },
      {
        path: 'overview',
        element: <NotFound />,
      },
      {
        path: TARS_AND_OUTAGES_PATH,
        children: [
          {
            path: 'events',
            children: [
              {
                path: '',
                element: <EventsPage />,
              },
              {
                path: ':eventId',
                element: <JobsPage />,
              },
            ],
          },
          {
            path: 'jobs/:jobId',
            element: <JobDetailsPage />,
          },
          {
            path: 'workpacks',
            element: <WorkpacksPage />,
          },
          {
            path: 'scaffolds',
            element: <ScaffoldsPage />,
          },
          {
            path: 'liftplans',
            element: <LiftplansPage />,
          },
          {
            path: 'insulations',
            element: <InsulationsPage />,
          },
          {
            path: 'isolations',
            element: <IsolationsPage />,
          },
          {
            path: 'emocs',
            element: <EmocsPage />,
          },
          {
            path: 'leaktestpacks',
            element: <LeakTestPacksPage />,
          },
          {
            path: 'procedures',
            element: <ProceduresPage />,
          },
          {
            path: 'purchaseorders',
            element: <PurchaseOrdersPage />,
          },
          {
            path: 'permits',
            element: <PermitsPage />,
          },
        ],
      },
      {
        path: MAINTANENCE_PATH,
        children: [
          {
            path: 'certificates',
            element: <CertificatesPage />,
          },
          {
            path: 'certificates/:certificateId',
            element: <CertificateDetailsPage />,
          },
          {
            path: 'certificates/search',
            element: <CertificateSearch />,
          },
          {
            path: 'certificates/monitoring',
            element: <CertificateMonitoringPage />,
          },
          {
            path: 'joints/:jointId',
            element: <JointDetails />,
          },
          {
            path: 'certificates/:certificateId/joints',
            element: <JointsView />,
          },
          {
            path: 'certificates/execute/:certificateId',
            element: <CertificateDetailsTabletPage />,
          },
        ],
      },
      {
        path: 'materials',
        element: <Materials />,
      },
      {
        path: 'faq',
        element: <FAQ />,
      },
    ],
  },
]);

export default router;
